import { topicTags } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            热门话题
          </h2>
          <div className="mt-4 w-16 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">当前站内最受关注的话题标签</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicTags.map((topic) => (
            <div
              key={topic.name}
              className="group p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer text-center"
            >
              <span className="block text-sm font-semibold text-accent-500 mb-1.5">
                {topic.heat}
              </span>
              <span className="block text-sm md:text-base font-semibold text-foreground-900 font-heading whitespace-nowrap">
                {topic.name}
              </span>
              <p className="mt-2 text-xs text-foreground-600 leading-snug hidden md:block">
                {topic.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}